import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, IconButton, Typography, Button } from '@mui/material';
import { WSIcons } from '../../../commonFunctions/iIcons';
import WSTextField from '../../../Components/TextBox/WSTextBox';
import { useForm } from 'react-hook-form';
import WSTextAreaField from '../../../Components/WSTextArea/WSTextArea';
import WSDateField from '../../../Components/DateField/WSDateField';
import WSSelectField from '../../../Components/Select/WSSelect';
import config from '../../../Config/clientConfig.json';

interface AmountPaidInfoProps {
  open: boolean;
  onClose: () => void;
}

export const AmountPaidInfo: React.FC<AmountPaidInfoProps> = ({ open, onClose }) => {
  const { handleSubmit, control, register } = useForm();

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth={true}
        maxWidth="lg"
        PaperProps={{
          style: {
            backgroundColor: 'whitesmoke',
            width: '80vw',
            height: '80vh',
          },
        }}
      >
        <DialogTitle sx={{ backgroundColor: 'green' }}>
          <Grid display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" color="white">
              Amount Paid
            </Typography>
            <IconButton onClick={onClose}>
              <WSIcons.CloseIcon sx={{ color: 'white' }} />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {/* Heading Grid to show both headings on the same line */}
            <Grid item xs={12}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={5}>
                  <Typography variant="h6" color="green" gutterBottom>
                    Payment Information
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography variant="h6" color="green" gutterBottom>
                    Payment Method
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* First Grid (Date, Amount Paid, Paid By, Remark) */}
            <Grid item xs={12} sm={5}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography>Date</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSDateField
                    id="date"
                    name="date"
                    dateFormat="D/MM/YYYY"
                    control={control}
                    defaultValue={null}
                    rules={{ required: true }}
                    label={""}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Amount Paid</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSTextField
                    label={""}
                    {...register("amountPaid")}
                    id="amountPaid"
                    name="amountPaid"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Paid By</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSTextField
                    label={""}
                    {...register("paidBy")}
                    id="paidBy"
                    name="paidBy"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography>Remark</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSTextAreaField
                    label={""}
                    id="remark"
                    name="remark"
                    control={control}
                    rules={{ required: false }}
                    rows={3}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Second Grid (Payment Type) */}
            <Grid item xs={12} sm={7}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography>Payment Type</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                  <WSSelectField
                    rules={{ required: true }}
                    {...register("payment")}
                    id="payment"
                    control={control}
                    defaultValue={"0"}
                    label=""
                    name="payment"
                    options={config.paymentTypesconfig.staticOptionData}
                  />
                </Grid>

                {/* "Cash Information" Heading */}
                <Grid item xs={12} sx={{ mt: 5 }}> {/* Add margin to create space */}
                  <Typography  gutterBottom sx={{backgroundColor:"grey",fontWeight:"bold"}}>
                    Cash Information
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography>Select Currency</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                <WSSelectField
                    rules={{ required: true }}
                    {...register("currency")}
                    id="currency"
                    control={control}
                    defaultValue={"0"}
                    label=""
                    name="currency"
                    options={config.currencyTypeconfig.staticOptionData}
                  />
                </Grid>
                <Grid item xs={12} >
                    <Typography>1 Rs = 1 Rs</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography>Amount Paid</Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                <WSTextField
                    label={""}
                    {...register("amountpaid")}
                    id="amountpaid"
                    name="amountpaid"
                    control={control}
                    rules={{ required: false }}
                  />
              
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>

        <Grid
          item
          sx={{
            backgroundColor: "#333",
            padding: "1rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
             <Grid container spacing={2} alignItems="center" gap={3}>
        <Grid item>
          <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        </Grid>
        
      </Grid>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "green",
              "&:hover": {
                backgroundColor: "#388e3c",
              },
            }}
          >
            Finish
          </Button>
        </Grid>
      </Dialog>
    </>
  );
};
